import { AccountID } from 'src/api/organization';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { action } from 'src/store/actions';

/* Organization statsitic */
export const FETCH_ORGANIZATION_STATISTIC = 'FETCH_ORGANIZATION_STATISTIC';
export const REQUEST_ORGANIZATION_STATISTIC = 'REQUEST_ORGANIZATION_STATISTIC';
export const SUCCESS_ORGANIZATION_STATISTIC = 'SUCCESS_ORGANIZATION_STATISTIC';
export const FAILURE_ORGANIZATION_STATISTIC = 'FAILURE_ORGANIZATION_STATISTIC';

export const fetchOrganizationStatistic = (id: AccountID) => action(FETCH_ORGANIZATION_STATISTIC, { id });
export const requestOrganizationStatistic = () => action(REQUEST_ORGANIZATION_STATISTIC);
export const requestOrganizationStatisticSuccess = (response: any) =>
    action(SUCCESS_ORGANIZATION_STATISTIC, { response });
export const requestOrganizationStatisticFailure = (error: any) => action(FAILURE_ORGANIZATION_STATISTIC, { error });

/* Organization overview */
export const FETCH_ORGANIZATION_OVERVIEW = 'FETCH_ORGANIZATION_OVERVIEW';
export const REQUEST_ORGANIZATION_OVERVIEW = 'REQUEST_ORGANIZATION_OVERVIEW';
export const SUCCESS_ORGANIZATION_OVERVIEW = 'SUCCESS_ORGANIZATION_OVERVIEW';
export const FAILURE_ORGANIZATION_OVERVIEW = 'FAILURE_ORGANIZATION_OVERVIEW';

export const fetchOrganizationOverview = (id: AccountID, pageable?: PageableQueryParams) =>
    action(FETCH_ORGANIZATION_OVERVIEW, { id, pageable });
export const requestOrganizationOverview = () => action(REQUEST_ORGANIZATION_OVERVIEW);
export const requestOrganizationOverviewSuccess = (response: any) =>
    action(SUCCESS_ORGANIZATION_OVERVIEW, { response });
export const requestOrganizationOverviewFailure = (error: any) => action(FAILURE_ORGANIZATION_OVERVIEW, { error });

/* Fetch Registered Events */
export const FETCH_REGISTERED_EVENTS = 'FETCH_REGISTERED_EVENTS';
export const REQUEST_REGISTERED_EVENTS = 'REQUEST_REGISTERED_EVENTS';
export const SUCCESS_REGISTERED_EVENTS = 'SUCCESS_REGISTERED_EVENTS';
export const FAILURE_REGISTERED_EVENTS = 'FAILURE_REGISTERED_EVENTS';

export const fetchRegisteredEvents = (id: AccountID, partnerId: number) =>
    action(FETCH_REGISTERED_EVENTS, { id, partnerId });
export const requestRegisteredEvents = () => action(REQUEST_REGISTERED_EVENTS);
export const requestRegisteredEventsSuccess = (response: any) => action(SUCCESS_REGISTERED_EVENTS, { response });
export const requestRegisteredEventsFailure = (error: any) => action(FAILURE_REGISTERED_EVENTS, { error });

/* Fetch Organization Customer Appliances */
export const FETCH_ORGANIZATION_CUSTOMER_APPLIANCES = 'FETCH_ORGANIZATION_CUSTOMER_APPLIANCES';
export const REQUEST_ORGANIZATION_CUSTOMER_APPLIANCES = 'REQUEST_ORGANIZATION_CUSTOMER_APPLIANCES';
export const SUCCESS_ORGANIZATION_CUSTOMER_APPLIANCES = 'SUCCESS_ORGANIZATION_CUSTOMER_APPLIANCES';
export const FAILURE_ORGANIZATION_CUSTOMER_APPLIANCES = 'FAILURE_ORGANIZATION_CUSTOMER_APPLIANCES';

export const fetchOrganizationCustomerAppliances = (sourceId: AccountID, targetId: AccountID) =>
    action(FETCH_ORGANIZATION_CUSTOMER_APPLIANCES, { sourceId, targetId });
export const requestOrganizationCustomerAppliances = () => action(REQUEST_ORGANIZATION_CUSTOMER_APPLIANCES);
export const requestOrganizationCustomerAppliancesSuccess = (response: any) =>
    action(SUCCESS_ORGANIZATION_CUSTOMER_APPLIANCES, { response });
export const requestOrganizationCustomerAppliancesFailure = (error: any) =>
    action(FAILURE_ORGANIZATION_CUSTOMER_APPLIANCES, { error });

/* Fetch Video List */
export const FETCH_VIDEO_LIST = 'FETCH_VIDEO_LIST';
export const REQUEST_VIDEO_LIST = 'REQUEST_VIDEO_LIST';
export const SUCCESS_VIDEO_LIST = 'SUCCESS_VIDEO_LIST';
export const FAILURE_VIDEO_LIST = 'FAILURE_VIDEO_LIST';

export const fetchVideoList = (id: AccountID, partnerId: number) => action(FETCH_VIDEO_LIST, { id, partnerId });
export const requestVideoList = () => action(REQUEST_VIDEO_LIST);
export const requestVideoListSuccess = (response: any) => action(SUCCESS_VIDEO_LIST, { response });
export const requestVideoListFailure = (error: any) => action(FAILURE_VIDEO_LIST, { error });

/* Fetch Organization Customer Orders */
export const FETCH_ORGANIZATION_CUSTOMER_ORDERS = 'FETCH_ORGANIZATION_CUSTOMER_ORDERS';
export const REQUEST_ORGANIZATION_CUSTOMER_ORDERS = 'REQUEST_ORGANIZATION_CUSTOMER_ORDERS';
export const SUCCESS_ORGANIZATION_CUSTOMER_ORDERS = 'SUCCESS_ORGANIZATION_CUSTOMER_ORDERS';
export const FAILURE_ORGANIZATION_CUSTOMER_ORDERS = 'FAILURE_ORGANIZATION_CUSTOMER_ORDERS';

export const fetchOrganizationCustomerOrders = (id: AccountID, partnerId: number, pageable?: PageableQueryParams) =>
    action(FETCH_ORGANIZATION_CUSTOMER_ORDERS, { id, partnerId, pageable });
export const requestOrganizationCustomerOrders = () => action(REQUEST_ORGANIZATION_CUSTOMER_ORDERS);
export const requestOrganizationCustomerOrdersSuccess = (response: any) =>
    action(SUCCESS_ORGANIZATION_CUSTOMER_ORDERS, { response });
export const requestOrganizationCustomerOrdersFailure = (error: any) =>
    action(FAILURE_ORGANIZATION_CUSTOMER_ORDERS, { error });

/* Fetch Organization Customer Data */
export const FETCH_ORGANIZATION_CUSTOMER_DATA = 'FETCH_ORGANIZATION_CUSTOMER_DATA';
export const REQUEST_ORGANIZATION_CUSTOMER_DATA = 'REQUEST_ORGANIZATION_CUSTOMER_DATA';
export const SUCCESS_ORGANIZATION_CUSTOMER_DATA = 'SUCCESS_ORGANIZATION_CUSTOMER_DATA';
export const FAILURE_ORGANIZATION_CUSTOMER_DATA = 'FAILURE_ORGANIZATION_CUSTOMER_DATA';

export const fetchOrganizationCustomerData = (sourceId: AccountID, targetId: AccountID) =>
    action(FETCH_ORGANIZATION_CUSTOMER_DATA, { sourceId, targetId });
export const requestOrganizationCustomerData = () => action(REQUEST_ORGANIZATION_CUSTOMER_DATA);
export const requestOrganizationCustomerDataSuccess = (response: any) =>
    action(SUCCESS_ORGANIZATION_CUSTOMER_DATA, { response });
export const requestOrganizationCustomerDataFailure = (error: any) =>
    action(FAILURE_ORGANIZATION_CUSTOMER_DATA, { error });

/* Fetch Organization Customer Addresses */
export const FETCH_ORGANIZATION_CUSTOMER_ADDRESSES = 'FETCH_ORGANIZATION_CUSTOMER_ADDRESSES';
export const REQUEST_ORGANIZATION_CUSTOMER_ADDRESSES = 'REQUEST_ORGANIZATION_CUSTOMER_ADDRESSES';
export const SUCCESS_ORGANIZATION_CUSTOMER_ADDRESSES = 'SUCCESS_ORGANIZATION_CUSTOMER_ADDRESSES';
export const FAILURE_ORGANIZATION_CUSTOMER_ADDRESSES = 'FAILURE_ORGANIZATION_CUSTOMER_ADDRESSES';

export const fetchOrganizationCustomerAddresses = (sourceId: AccountID, targetId: AccountID) =>
    action(FETCH_ORGANIZATION_CUSTOMER_ADDRESSES, { sourceId, targetId });
export const requestOrganizationCustomerAddresses = () => action(REQUEST_ORGANIZATION_CUSTOMER_ADDRESSES);
export const requestOrganizationCustomerAddressesSuccess = (response: any) =>
    action(SUCCESS_ORGANIZATION_CUSTOMER_ADDRESSES, { response });
export const requestOrganizationCustomerAddressesFailure = (error: any) =>
    action(FAILURE_ORGANIZATION_CUSTOMER_ADDRESSES, { error });

/* Fetch Organization Customer Landingpages */
export const FETCH_ORGANIZATION_CUSTOMER_LANDINGPAGES = 'FETCH_ORGANIZATION_CUSTOMER_LANDINGPAGES';
export const REQUEST_ORGANIZATION_CUSTOMER_LANDINGPAGES = 'REQUEST_ORGANIZATION_CUSTOMER_LANDINGPAGES';
export const SUCCESS_ORGANIZATION_CUSTOMER_LANDINGPAGES = 'SUCCESS_ORGANIZATION_CUSTOMER_LANDINGPAGES';
export const FAILURE_ORGANIZATION_CUSTOMER_LANDINGPAGES = 'FAILURE_ORGANIZATION_CUSTOMER_LANDINGPAGES';

export const fetchOrganizationCustomerLandingpages = (sourceId: AccountID, targetId: AccountID) =>
    action(FETCH_ORGANIZATION_CUSTOMER_LANDINGPAGES, { sourceId, targetId });
export const requestOrganizationCustomerLandingpages = () => action(REQUEST_ORGANIZATION_CUSTOMER_LANDINGPAGES);
export const requestOrganizationCustomerLandingpagesSuccess = (response: any) =>
    action(SUCCESS_ORGANIZATION_CUSTOMER_LANDINGPAGES, { response });
export const requestOrganizationCustomerLandingpagesFailure = (error: any) =>
    action(FAILURE_ORGANIZATION_CUSTOMER_LANDINGPAGES, { error });

/* Fetch Organization Customer Referral Partner */
export const FETCH_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER = 'FETCH_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER';
export const REQUEST_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER = 'REQUEST_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER';
export const SUCCESS_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER = 'SUCCESS_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER';
export const FAILURE_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER = 'FAILURE_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER';

export const fetchOrganizationCustomerReferralPartner = (sourceId: AccountID, targetId: AccountID) =>
    action(FETCH_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER, { sourceId, targetId });
export const requestOrganizationCustomerReferralPartner = () => action(REQUEST_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER);
export const requestOrganizationCustomerReferralPartnerSuccess = (response: any) =>
    action(SUCCESS_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER, { response });
export const requestOrganizationCustomerReferralPartnerFailure = (error: any) =>
    action(FAILURE_ORGANIZATION_CUSTOMER_REFERRAL_PARTNER, { error });

/* Fetch Organization Customer Enables */
export const FETCH_ORGANIZATION_CUSTOMER_ENABLES = 'FETCH_ORGANIZATION_CUSTOMER_ENABLES';
export const REQUEST_ORGANIZATION_CUSTOMER_ENABLES = 'REQUEST_ORGANIZATION_CUSTOMER_ENABLES';
export const SUCCESS_ORGANIZATION_CUSTOMER_ENABLES = 'SUCCESS_ORGANIZATION_CUSTOMER_ENABLES';
export const FAILURE_ORGANIZATION_CUSTOMER_ENABLES = 'FAILURE_ORGANIZATION_CUSTOMER_ENABLES';

export const fetchOrganizationCustomerEnables = (sourceId: AccountID, targetId: AccountID) =>
    action(FETCH_ORGANIZATION_CUSTOMER_ENABLES, { sourceId, targetId });
export const requestOrganizationCustomerEnables = () => action(REQUEST_ORGANIZATION_CUSTOMER_ENABLES);
export const requestOrganizationCustomerEnablesSuccess = (response: any) =>
    action(SUCCESS_ORGANIZATION_CUSTOMER_ENABLES, { response });
export const requestOrganizationCustomerEnablesFailure = (error: any) =>
    action(FAILURE_ORGANIZATION_CUSTOMER_ENABLES, { error });

/* Fetch Favorites */
export const FETCH_ORGANIZATION_FAVORITES = 'FETCH_ORGANIZATION_FAVORITES';
export const REQUEST_ORGANIZATION_FAVORITES = 'REQUEST_ORGANIZATION_FAVORITES';
export const SUCCESS_ORGANIZATION_FAVORITES = 'SUCCESS_ORGANIZATION_FAVORITES';
export const FAILURE_ORGANIZATION_FAVORITES = 'FAILURE_ORGANIZATION_FAVORITES';

export const fetchOrganizationFavorites = (id: AccountID) => action(FETCH_ORGANIZATION_FAVORITES, { id });
export const requestOrganizationFavorites = () => action(REQUEST_ORGANIZATION_FAVORITES);
export const requestOrganizationFavoritesSuccess = (response: any) =>
    action(SUCCESS_ORGANIZATION_FAVORITES, { response });
export const requestOrganizationFavoritesFailure = (error: any) => action(FAILURE_ORGANIZATION_FAVORITES, { error });

/* Fetch Organization Customers */
export const FETCH_ORGANIZATION_CUSTOMERS = 'FETCH_ORGANIZATION_CUSTOMERS';
export const REQUEST_ORGANIZATION_CUSTOMERS = 'REQUEST_ORGANIZATION_CUSTOMERS';
export const SUCCESS_ORGANIZATION_CUSTOMERS = 'SUCCESS_ORGANIZATION_CUSTOMERS';
export const FAILURE_ORGANIZATION_CUSTOMERS = 'FAILURE_ORGANIZATION_CUSTOMERS';

export const fetchOrganizationCustomers = (id: AccountID, pageable?: PageableQueryParams) =>
    action(FETCH_ORGANIZATION_CUSTOMERS, { id, pageable });
export const requestOrganizationCustomers = () => action(REQUEST_ORGANIZATION_CUSTOMERS);
export const requestOrganizationCustomersSuccess = (response: any) =>
    action(SUCCESS_ORGANIZATION_CUSTOMERS, { response });
export const requestOrganizationCustomersFailure = (error: any) => action(FAILURE_ORGANIZATION_CUSTOMERS, { error });

/* Fetch Organization Sis Partners */
export const FETCH_ORGANIZATION_SIS_PARTNERS = 'FETCH_ORGANIZATION_SIS_PARTNERS';
export const REQUEST_ORGANIZATION_SIS_PARTNERS = 'REQUEST_ORGANIZATION_SIS_PARTNERS';
export const SUCCESS_ORGANIZATION_SIS_PARTNERS = 'SUCCESS_ORGANIZATION_SIS_PARTNERS';
export const FAILURE_ORGANIZATION_SIS_PARTNERS = 'FAILURE_ORGANIZATION_SIS_PARTNERS';

export const fetchOrganizationSisPartners = (id: AccountID, pageable?: PageableQueryParams) =>
    action(FETCH_ORGANIZATION_SIS_PARTNERS, { id, pageable });
export const requestOrganizationSisPartners = () => action(REQUEST_ORGANIZATION_SIS_PARTNERS);
export const requestOrganizationSisPartnersSuccess = (response: any) =>
    action(SUCCESS_ORGANIZATION_SIS_PARTNERS, { response });
export const requestOrganizationSisPartnersFailure = (error: any) =>
    action(FAILURE_ORGANIZATION_SIS_PARTNERS, { error });

/* Fetch Organization Licensors */
export const FETCH_ORGANIZATION_LICENSORS = 'FETCH_ORGANIZATION_LICENSORS';
export const REQUEST_ORGANIZATION_LICENSORS = 'REQUEST_ORGANIZATION_LICENSORS';
export const SUCCESS_ORGANIZATION_LICENSORS = 'SUCCESS_ORGANIZATION_LICENSORS';
export const FAILURE_ORGANIZATION_LICENSORS = 'FAILURE_ORGANIZATION_LICENSORS';

export const fetchOrganizationLicensors = (id: AccountID, pageable?: PageableQueryParams) =>
    action(FETCH_ORGANIZATION_LICENSORS, { id, pageable });
export const requestOrganizationLicensors = () => action(REQUEST_ORGANIZATION_LICENSORS);
export const requestOrganizationLicensorsSuccess = (response: any) =>
    action(SUCCESS_ORGANIZATION_LICENSORS, { response });
export const requestOrganizationLicensorsFailure = (error: any) => action(FAILURE_ORGANIZATION_LICENSORS, { error });

/* Fetch Organization Placements */
export const FETCH_ORGANIZATION_PLACEMENTS = 'FETCH_ORGANIZATION_PLACEMENTS';
export const REQUEST_ORGANIZATION_PLACEMENTS = 'REQUEST_ORGANIZATION_PLACEMENTS';
export const SUCCESS_ORGANIZATION_PLACEMENTS = 'SUCCESS_ORGANIZATION_PLACEMENTS';
export const FAILURE_ORGANIZATION_PLACEMENTS = 'FAILURE_ORGANIZATION_PLACEMENTS';

export const fetchOrganizationPlacements = (id: AccountID, pageable?: PageableQueryParams) =>
    action(FETCH_ORGANIZATION_PLACEMENTS, { id, pageable });
export const requestOrganizationPlacements = () => action(REQUEST_ORGANIZATION_PLACEMENTS);
export const requestOrganizationPlacementsSuccess = (response: any) =>
    action(SUCCESS_ORGANIZATION_PLACEMENTS, { response });
export const requestOrganizationPlacementsFailure = (error: any) => action(FAILURE_ORGANIZATION_PLACEMENTS, { error });

/* Fetch Organization Office Profis */
export const FETCH_ORGANIZATION_OFFICE_PROFIS = 'FETCH_ORGANIZATION_OFFICE_PROFIS';
export const REQUEST_ORGANIZATION_OFFICE_PROFIS = 'REQUEST_ORGANIZATION_OFFICE_PROFIS';
export const SUCCESS_ORGANIZATION_OFFICE_PROFIS = 'SUCCESS_ORGANIZATION_OFFICE_PROFIS';
export const FAILURE_ORGANIZATION_OFFICE_PROFIS = 'FAILURE_ORGANIZATION_OFFICE_PROFIS';

export const fetchOrganizationOfficeProfis = (id: AccountID, pageable?: PageableQueryParams) =>
    action(FETCH_ORGANIZATION_OFFICE_PROFIS, { id, pageable });
export const requestOrganizationOfficeProfis = () => action(REQUEST_ORGANIZATION_OFFICE_PROFIS);
export const requestOrganizationOfficeProfisSuccess = (response: any) =>
    action(SUCCESS_ORGANIZATION_OFFICE_PROFIS, { response });
export const requestOrganizationOfficeProfisFailure = (error: any) =>
    action(FAILURE_ORGANIZATION_OFFICE_PROFIS, { error });
